module.exports = __webpack_public_path__ + "static/media/lds-logo_no.df12880c.svg";